import React from 'react';
import { Viewer } from '@react-pdf-viewer/core';
import '@react-pdf-viewer/core/lib/styles/index.css'; // Importer les styles CSS nécessaires

const PDFViewer = ({ pdfFile }) => {
    return (
        <div style={{ height: '750px' }}>
            <Viewer fileUrl={pdfFile} />
        </div>
    );
};

export default PDFViewer;
